export enum InboundEmailMessageStatus {
  Processing = 'Processing',
  New = 'New',
  Completed = 'Completed',
  Canceled = 'Canceled',
}
